/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import CampaignModel from 'cio/models/campaign';

const CUTOFF_LIMIT = 5;

interface FormsFormCampaignsUsageListArgs {
  campaigns: CampaignModel[];
}

export default class FormsFormCampaignsUsageList extends Component<FormsFormCampaignsUsageListArgs> {
  @tracked isShowingAll = false;

  get visibleCampaigns() {
    return this.isShowingAll ? this.args.campaigns : this.args.campaigns.slice(0, CUTOFF_LIMIT);
  }

  get hiddenCampaignsCount() {
    return this.args.campaigns.length - this.visibleCampaigns.length;
  }
}
